// extracted by mini-css-extract-plugin
module.exports = {"container":"MainUI_container__3Q5ki"};